import { Button, ProfileNavbarMenu } from 'src/components'
import { NavLink } from 'react-router-dom'
import { Close, Logo } from 'src/assets'
import { motion } from 'framer-motion'
import { ROUTE_HOME } from 'src/lib'

const mobileMenuVariant = {
  opened: {
    y: '0%',
    transition: { delay: 0.15, duration: 0.63, ease: [0.74, 0, 0.19, 1.02] },
  },
  closed: {
    y: '-100%',
    transition: { delay: 0.35, duration: 0.63, ease: [0.74, 0, 0.19, 1.02] },
  },
}

const fadeInVariant = {
  opened: {
    opacity: 1,
    transition: { delay: 0.73 },
  },
  closed: { opacity: 0 },
}

const ulVariant = {
  opened: {
    transition: { delayChildren: 0.73, staggerChildren: 0.18 },
  },
  closed: {
    transition: { staggerChildren: 0.06, staggerDirection: -1 },
  },
}

interface Props {
  toggleMenu: () => void
}

const NavbarMenu = ({ toggleMenu }: Props) => {
  return (
    <motion.div
      variants={mobileMenuVariant}
      className='fixed top-0 left-0 h-screen w-full flex flex-col items-center bg-light-gray z-[500]'
    >
      <motion.div
        variants={fadeInVariant}
        className='px-[20px] min-h-[60px] max-h-[60px] flex items-center justify-between min-w-full'
      >
        <NavLink onClick={toggleMenu} to={ROUTE_HOME}>
          <Logo />
        </NavLink>
        <Button
          icon={<Close className='fill-dark-gray !w-[16px] !h-[16px]' />}
          size='m'
          onClick={toggleMenu}
          theme='secondary-ghost'
        />
      </motion.div>
      <motion.ul
        variants={ulVariant}
        onClick={toggleMenu}
        className='list-none w-full h-full box-border'
      >
        <ProfileNavbarMenu />
      </motion.ul>
    </motion.div>
  )
}

export default NavbarMenu
